import React, { useEffect, useState } from 'react'
import Layout from '../layout/Layout'
import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';
import Table from "react-bootstrap/Table";
import Form from "react-bootstrap/Form";
import ScrollingTab from '../components/ScrollingTab';
import CustomFormInput from '../components/CustomFormInput';
import CustomPagination from '../components/CustomPagination';
import DeleteModal from '../components/DeleteModal';
import { deleteTicket, getTicketList, ticketStatus } from '../controller';
import { requestHandler } from '../helper';
import Loader from '../components/Loader';
import { formatDate } from '../helper/common';
import { toast } from 'react-toastify';

function FeedbackSupport() {

  const [show, setShow] = useState(false);
  const [search, setSearch] = useState("");
  const [selectedTicket, setSelectedTicket] = useState({});

  const handleClose = () => setShow(false);
  const [userSupport, setUserSupport] = useState([]);
  const [loading, setLoading] = useState(true);
  const [paginationValue, setPaginationValue] = useState({
    page: 1,
    limit: 10,
    totalData: 0,
    totalPages: 0
  })
  const { page, limit, totalData, totalPages } = paginationValue
  const start = (page - 1) * limit + 1;
  const end = Math.min(page * limit, totalData);


  const handleStatusChange = async (id, newStatus) => {
    setUserSupport(prevSupport =>
      prevSupport.map(item =>
        item._id === id ? { ...item, status: newStatus } : item
      )
    );
    await requestHandler(
      async () => await ticketStatus({ status: newStatus }, id),
      setLoading,
      (res) => {
        toast.success(res.message);
        getSupportList();
      },
      () => { }
    );
  };


  const handleDeleteTicket = (ticket) => {
    setSelectedTicket(ticket);
    setShow(true);
  };

  const handleDelete = async () => {
    await requestHandler(
      async () => await deleteTicket(selectedTicket._id),
      setLoading,
      (res) => {
        toast.success(res.message);
        getSupportList(1);
        setShow(false);
        setSelectedTicket(null);
      },
      () => { }
    );
  }

  const getStatusColorClass = (status) => {
    switch (status) {
      case 0:
        return 'text-success';
      case 1:
        return 'text-warning';
      case 2:
        return 'text-danger';
      default:
        return '';
    }
  };



  const getSupportList = async () => {
    await requestHandler(
      async () => await getTicketList(limit, page, search),
      setLoading,
      (res) => {
        const { data, limit, page, totalData, totalPages } = res.data;
        setUserSupport(data);
        setPaginationValue({
          page,
          limit,
          totalData,
          totalPages
        })
      },
      () => { }
    );
  }

  useEffect(() => {
    if (search) {
      const delayDebounce = setTimeout(() => {
        getSupportList(1);
      }, 500);
      return () => clearTimeout(delayDebounce);
    } else {

      getSupportList(1);
    }
    // eslint-disable-next-line
  }, [page, search, paginationValue.limit]);


  return (
    <>
      {loading && <Loader />}
      <Layout>
        <div className="card-wrapper">
          <div className="card-header border-bottom-0 pb-0">
            <div className='theme-select'>
              <Form.Select required name="limit" onChange={e => setPaginationValue({ ...paginationValue, [e.target.name]: e.target.value })}>
                <option >10</option>
                <option >15</option>
                <option >20</option>
              </Form.Select>
            </div>
            <div className="d-flex align-items-center gap-2">
              <div className="search-input">
                <img src="/images/svg/search.svg" className="search-icon" alt="icon" />
                <CustomFormInput
                  type="search"
                  placeholder="Search here..."
                  id="search"
                  value={search}
                  name='search'
                  onChange={(e) => setSearch(e.target.value)}
                  className="mb-0"
                />
              </div>
            </div>
          </div>
          <div className="card-body">
            <Tab.Container id="activityTab" defaultActiveKey="userSupport">
              <ScrollingTab>
                <Nav className='theme-tab'>
                  <Nav.Item>
                    <Nav.Link eventKey="userSupport">User Support Tickets</Nav.Link>
                  </Nav.Item>
                </Nav>
              </ScrollingTab>
              <Tab.Content className='mt-3'>
                <Tab.Pane eventKey="userSupport">
                  <div className="overflow-x-auto theme-scrollbar">
                    <Table className="theme-table">
                      <thead>
                        <tr>
                          <th>Username</th>
                          <th>Email</th>
                          <th>Subject</th>
                          <th>Issue</th>
                          <th>Date</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Boolean(userSupport.length) ? userSupport.map((support, index) => (
                          <tr key={index}>
                            <td>{support?.userId?.userName || '-'}</td>
                            <td>{support?.userId?.email || '-'}</td>
                            <td>{support?.subject || '-'}</td>
                            <td style={{ minWidth: '200px' }}>{support.issue || '-'}</td>
                            <td>{formatDate(support.createdAt)}</td>
                            <td width={180} style={{ minWidth: '180px' }}>
                              {support.status === 2 ? <p className="text-danger" >
                                Closed
                              </p> :
                                <div className='theme-select'>
                                  <Form.Select
                                    value={support.status}
                                    onChange={(e) => handleStatusChange(support._id, Number(e.target.value))}
                                    // className={getStatusColorClass(support.status)}
                                    className={`form-select ${getStatusColorClass(support.status)}`}
                                  >
                                    <option className="text-success" value={0}>Open</option>
                                    <option className="text-warning" value={1}>In Progress</option>
                                    <option className="text-danger" value={2}>Closed</option>
                                  </Form.Select>
                                </div>
                              }
                            </td>
                            <td width={65}>
                              <div className="d-flex align-items-center gap-2">
                                <button className="table-icon border-danger-light" onClick={() => handleDeleteTicket(support)}>
                                  <img src="/images/svg/table-delete.svg" alt="icon" />
                                </button>
                              </div>
                            </td>
                          </tr>
                        )) : (
                          <tr>
                            <td colSpan={10} className='text-center p-5 fs-5'>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                  <div className="d-flex align-items-center justify-content-between gap-2 flex-wrap mt-1">
                    <p className="mb-0 fs-16 fw-500 text-light">
                      Showing {end === 0 ? 0 : start} to {end} of {totalData} entries
                    </p>
                    {totalPages > 1 && (
                      <CustomPagination
                        currentPage={page}
                        totalPages={totalPages}
                        onPageChange={getSupportList}
                      />
                    )}
                  </div>
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </div>
        </div>
      </Layout>
      <DeleteModal show={show} handleClose={handleClose} handleDelete={handleDelete} message="Are you sure you want to delete this support ticket?" />
    </>
  )
}

export default FeedbackSupport